import { useCurrentUser } from '@/app/hooks/useCurrentUser';
import { useGetMyActiveGoodHabit } from '@/src/api/client';
import { isActiveGoodHabitResponse } from '@/src/api/utils';

export const useLoadMyGoodHabit = () => {
  const { currentUser } = useCurrentUser();
  const { data: activeGoodHabitData, isLoading } = useGetMyActiveGoodHabit({ query: { enabled: !!currentUser } });

  const activeGoodHabit = isActiveGoodHabitResponse(activeGoodHabitData) ? activeGoodHabitData : undefined;

  return {
    activeGoodHabit,
    isLoadingGoodHabit: isLoading,
  };
};
